import AsyncStorage from "@react-native-async-storage/async-storage";
import { Linking } from "react-native";
import { VendaComItens } from "../types/database";
import { formatarDataBr } from "./dataVencimento";

const PIX_CHAVE_KEY = "pix_chave";
const PIX_TITULAR_KEY = "pix_titular";

async function buscarConfiguracaoPix(): Promise<{
  chave: string;
  titular: string;
} | null> {
  try {
    const [chaveSalva, titularSalvo] = await Promise.all([
      AsyncStorage.getItem(PIX_CHAVE_KEY),
      AsyncStorage.getItem(PIX_TITULAR_KEY),
    ]);

    const chave = chaveSalva?.trim();
    const titular = titularSalvo?.trim();

    if (!chave) {
      return null;
    }

    return { chave, titular: titular || "Titular não informado" };
  } catch (error) {
    console.warn("Erro ao carregar configuração de Pix:", error);
    return null;
  }
}

export async function montarMensagemCobranca(
  venda: VendaComItens,
): Promise<string> {
  const linhasItens = venda.itens_venda
    .map((item) => {
      const nome = item.nome_produto ?? item.produtos?.nome ?? "Produto";
      return `- ${item.quantidade}x ${nome}: R$ ${item.subtotal.toFixed(2)}`;
    })
    .join("\n");

  const incluirVencimento = venda.modalidade === "a prazo";
  const trechoVencimento = incluirVencimento
    ? ` Vencimento: ${formatarDataBr(venda.vencimento)}.`
    : "";
    

  const nomeTratado = (venda.graduacao === "Civil" || !venda.graduacao) 
    ? venda.cliente_nome 
    : `${venda.graduacao} ${venda.cliente_nome}`;

  const mensagemBase =
    `Olá, ${nomeTratado}! Segue o resumo do seu consumo:\n` +
    `${linhasItens}\n\n` +
    `Total: R$ ${venda.valor_total.toFixed(2)}.` +
    trechoVencimento;

  const configuracaoPix = await buscarConfiguracaoPix();

  if (!configuracaoPix) {
    return mensagemBase;
  }

  return (
    `${mensagemBase}\n\n` +
    `Para facilitar, minha chave Pix é: ${configuracaoPix.chave} - ${configuracaoPix.titular}.\n\n` +
    `Após o pagamento, por favor, envie o comprovante por aqui.`
  );
}

export function formatarTelefoneWhatsApp(telefone: string): string {
  const digitos = telefone.replace(/\D/g, "");
  if (digitos.startsWith("55")) return digitos;
  return `55${digitos}`;
}

export async function abrirWhatsAppCobranca(
  venda: VendaComItens,
): Promise<void> {
  const mensagem = await montarMensagemCobranca(venda);
  const telefone = formatarTelefoneWhatsApp(venda.telefone);
  const url = `https://wa.me/${telefone}?text=${encodeURIComponent(mensagem)}`;

  const podeAbrir = await Linking.canOpenURL(url);
  if (!podeAbrir) {
    throw new Error("Não foi possível abrir o WhatsApp neste dispositivo.");
  }

  await Linking.openURL(url);
}
